import UploadRow from "../uploadRow";
import {useGetKeysProgress, usePostKeyProgress} from "../../../../../_metronic/api/hooks";
import {toast} from "react-toastify";
import Loading from "../../../../../_metronic/layout/components/loading/Loading";
import React from "react";

const KeysProgress = () => {
    const {data, isLoading} = useGetKeysProgress()
    const {mutate} = usePostKeyProgress()
    const handleChangeAvatar = (file:File) => {
        const formData = new FormData();
        formData.append('file', file);
        mutate(formData, {
            onSuccess: () => {
                toast.success("Key-Progress-Animation successfully uploaded");
            },
            onError: () => {
                toast.error("file was not successfully uploaded, try again")
            }
        })
    }
    return <div className="w-100 d-flex flex-column">
        {/*<h3 className="mb-5">Global Files</h3>*/}
        {isLoading && <div className="d-flex w-100 justify-content-center"><Loading/></div>}
        {!isLoading && <UploadRow title="Key-Progress-Animation" accept=".json" onUpload={handleChangeAvatar} className="mt-5"
                    isExists={data?.has_animation}/>}
    </div>
}
export default KeysProgress